type ProgressPanelProps = {
  status: string;
  progress: number;
};

const STATUS_MESSAGES: Record<string, string> = {
  queued: 'Queued for validation',
  processing: 'Extracting text and running model analysis',
  complete: 'Analysis complete',
  failed: 'Analysis failed',
};

export function ProgressPanel({ status, progress }: ProgressPanelProps) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-teal-700">Analysis Progress</p>
          <h2 className="mt-2 text-2xl font-semibold text-slate-900">{STATUS_MESSAGES[status] ?? status}</h2>
        </div>
        <p className="text-3xl font-semibold text-slate-900">{progress}%</p>
      </div>
      <div className="mt-5 h-3 overflow-hidden rounded-full bg-slate-200">
        <div
          className="h-full rounded-full bg-gradient-to-r from-teal-700 via-sky-500 to-emerald-400 transition-all"
          style={{ width: `${Math.max(progress, 6)}%` }}
        />
      </div>
    </section>
  );
}
